import React from "react";
import CONST from "../../config/CONST";
import {useSelector} from "react-redux";
import {getAppData} from "../../store/slices/appSlice";
import {getFinancialConfiguration} from "../../store/slices/financialConfigurationsSlice";
import {disclaimerProxy} from "../../classes/disclaimerProxy";
import {useTranslation} from "react-i18next";
// import {logErr} from "../../helpers/debugLog";
// import isStringValidHtml from "../../helpers/isStringValidHtml";




const Disclaimer = () => {

    const { t } = useTranslation();

    const appData = useSelector(getAppData);
    const financialProductConfiguration = useSelector(getFinancialConfiguration);

    if(!appData || !financialProductConfiguration) {
        return null;
    }

    const dynamicDisclaimerObject = new disclaimerProxy('disclaimerObject_' + appData.config.lang);

    const disclaimer = dynamicDisclaimerObject.getDisclaimer({
        financialProduct: financialProductConfiguration,
    });

    /*
    const isValidHtml = isStringValidHtml(disclaimer);
    if(!isValidHtml.isStringValidHtml) {
        logErr('Invalid HTML markup in disclaimer');
        return null;
    }
    */

    return (
        <>
            <div className={`${CONST.CSS_NAMESPACE}Disclaimer`} >
                <h2>{t(`Disclaimer_${financialProductConfiguration?.productTypeCode}`)}</h2>
                <p dangerouslySetInnerHTML={{__html: disclaimer
                        .replaceAll('{validityDateFrom}', `${financialProductConfiguration?.validityDateFrom}`)
                        .replaceAll('{validityDateTo}', `${financialProductConfiguration?.validityDateTo}`)
                }} />
            </div>

        </>
    );
};


export default Disclaimer;
